import * as React from "react";
const IconStartRecording = (props: any) => (
    <svg width={40} height={40} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
        {/* <circle cx={12} cy={12} r={12} stroke="white" strokeWidth={2} fill="none" /> */}
        <path
            fill="#ff0100"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
        />
    </svg>
);
export default IconStartRecording;
